import React from 'react';
import { FaTimes } from 'react-icons/fa';
import trashIcon from '../../assets/trash.svg';
import './DeleteMinisiteModal.css';

const DeleteMinisiteModal = ({ isOpen, onClose, onConfirm, minisite, loading = false, error = null }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };

    const handleConfirm = () => {
        if (!loading && onConfirm) {
            onConfirm();
        }
    };

    return (
        <div className="delete-minisite-modal-overlay" onClick={handleBackdropClick}>
            <div className="delete-minisite-modal">
                <button
                    className="delete-minisite-modal-close"
                    onClick={onClose}
                    disabled={loading}
                    aria-label="Close"
                >
                    <FaTimes size={9.33} />
                </button>

                <div className="delete-minisite-modal-icon">
                    <img src={trashIcon} alt="Delete" />
                </div>

                <h2 className="delete-minisite-modal-title">Delete Minisite</h2>

                <p className="delete-minisite-modal-description">
                    Are you sure you want to delete "{minisite?.title}"? This action cannot be undone.
                </p>

                {error && <p className="delete-minisite-modal-error">{error}</p>}

                <div className="delete-minisite-modal-actions">
                    <button
                        className="delete-minisite-modal-cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className="delete-minisite-modal-delete"
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteMinisiteModal;
